const VIEW_ALIASES = {
  presentation: "presentation",
  estimate: "estimate",
  salesOrder: "salesOrder",
  depositInvoice: "depositInvoice",
  invoice: "depositInvoice",
  purchaseOrder: "purchaseOrder",
};

const toValue = (v) => (v === undefined || v === null ? null : v);

export const getHeaderConfig = (viewConfigs, viewKey) => {
  const key = VIEW_ALIASES[viewKey] || viewKey;
  const cfg = viewConfigs?.[key]?.header || {};
  return {
    logoUrl: toValue(cfg.logoUrl),
    backgroundUrl: toValue(cfg.backgroundUrl),
    backgroundColor: toValue(cfg.backgroundColor),
    companyName: toValue(cfg.companyName),
  };
};

export const getFooterConfig = (viewConfigs, viewKey) => {
  const key = VIEW_ALIASES[viewKey] || viewKey;
  const cfg = viewConfigs?.[key]?.footer || {};
  return {
    repType: toValue(cfg.repType),
    addressId: toValue(cfg.addressId),
    termsHtml: toValue(cfg.termsHtml),
  };
};
